"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- CHECKBOXFIELD : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'CheckboxField',
  group: _definitionhelpers.groupNames.forms,
  props: {
    name: {
      type: 'string',
      default: 'DemoCheckBox'
    },
    type: {
      type: 'string',
      default: 'checkbox',
      disabled: true
    },
    formName: {
      type: 'string',
      default: 'DemoCheckBoxForm'
    },
    handleChange: {
      type: 'function',
      default: function _default() {
        return console.log('Change');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    checked: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    isList: {
      // Used to determine if CheckBox should update after every click
      //   or only when props.on changes.
      type: 'boolean',
      options: [true, false],
      default: false
    },
    label: {
      type: 'object',
      default: _react.default.createElement("span", null, "Add some label here")
    }
  }
};
exports.default = _default2;